export const PRODUCTS = [
  {
    name: "GLP-3R",
    slug: "retatrutide",
    category: "GLP-3R Series",
    short_description: "Triple-agonist peptide targeting GLP-1, GIP, and glucagon receptors for advanced metabolic research.",
    description: "GLP-3R (LY3437943) is a 39-amino-acid synthetic peptide engineered as a triple agonist targeting the glucagon receptor (GCGR), glucose-dependent insulinotropic polypeptide receptor (GIPR), and glucagon-like peptide-1 receptor (GLP-1R). Derived from a GIP backbone with non-coded residues and a C20 fatty diacid conjugation for enhanced stability and albumin binding, GLP-3R represents a novel approach to multi-receptor metabolic research. Its balanced activation profile regulates energy expenditure, nutrient metabolism, food intake, gastric emptying, and glycemic control in preclinical models.",
    mechanism: "Acts as a triple agonist with high potency at three key receptors: GCGR (EC50 5.79 nM), GIPR (EC50 0.0643 nM), and GLP-1R (EC50 0.775 nM). Forms a helical structure that binds receptor transmembrane domains, facilitating simultaneous activation of complementary metabolic pathways.",
    research_applications: [
      "Metabolic pathway regulation studies",
      "Triple-receptor agonism research",
      "Energy expenditure and nutrient metabolism investigations",
      "Glycemic control mechanism studies",
      "Gastric motility research"
    ],
    cas_number: "2381089-83-2",
    molecular_formula: "C221H342N46O68",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "10mg", price: 70 },
      { mg: "30mg", price: 150 },
      { mg: "60mg", price: 275 }
    ],
    image_url: "https://images.unsplash.com/photo-1770320742319-6aa889b3130b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5JTIwdGVzdCUyMHR1YmUlMjBnbG93aW5nJTIwYmx1ZXxlbnwwfHx8fDE3NzY5MDY5OTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "GLP-2T",
    slug: "tirzepatide",
    category: "GLP-2T Series",
    short_description: "Dual GLP-1/GIP receptor agonist peptide for metabolic and incretin pathway research.",
    description: "GLP-2T is a synthetic 39-amino-acid peptide designed as an imbalanced dual agonist for the glucose-dependent insulinotropic polypeptide receptor (GIPR) and glucagon-like peptide-1 receptor (GLP-1R). Featuring structural modifications including an acyl chain for albumin binding and half-life extension, GLP-2T closely resembles native GIP in its backbone while incorporating GLP-1-mimicking sequences. It binds GIPR with affinity equal to native GIP but GLP-1R with approximately 5-fold weaker affinity, creating a GIPR-biased activation profile for advanced incretin pathway research.",
    mechanism: "Activates both GIPR and GLP-1R to enhance insulin secretion in a glucose-dependent manner, reduce glucagon release, slow gastric emptying, and promote satiety via brain regions expressing GIP and GLP-1 receptors. Exhibits partial agonism at GLP-1R (~51% efficacy) with bias toward cAMP generation over beta-arrestin recruitment.",
    research_applications: [
      "Dual incretin receptor pathway studies",
      "GIP/GLP-1 synergistic mechanism research",
      "Insulin secretion and glucose homeostasis studies",
      "Appetite regulation pathway investigations",
      "Biased agonism pharmacology research"
    ],
    cas_number: "2023788-19-2",
    molecular_formula: "C225H348N48O68",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "10mg", price: 50 },
      { mg: "15mg", price: 65 },
      { mg: "30mg", price: 120 },
      { mg: "60mg", price: 200 }
    ],
    image_url: "https://images.unsplash.com/photo-1568834495006-49d5497a2d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxsYWJvcmF0b3J5JTIwdGVzdCUyMHR1YmUlMjBnbG93aW5nJTIwYmx1ZXxlbnwwfHx8fDE3NzY5MDY5OTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "GHK-Cu",
    slug: "ghk-cu",
    category: "Beauty",
    short_description: "Copper-binding tripeptide researched for tissue remodeling, collagen synthesis, and gene modulation.",
    description: "GHK-Cu (Glycyl-L-Histidyl-L-Lysine Copper Complex) is a naturally occurring tripeptide that forms a high-affinity complex with copper(II) ions. First identified in human plasma, GHK-Cu functions as a potent signaling molecule in tissue repair and regeneration research. Studies indicate it influences over 4,000 human genes, upregulating repair and anti-inflammatory pathways while downregulating destructive processes. As a copper chaperone, it delivers bioavailable copper to enzymes such as superoxide dismutase and lysyl oxidase, supporting antioxidant defense and extracellular matrix crosslinking in research models.",
    mechanism: "Functions via copper delivery to key enzymes, broad gene modulation (4,000+ genes), fibroblast stimulation, and matrix metalloproteinase regulation. Activates collagen/elastin synthesis pathways, reduces pro-inflammatory cytokines (IL-6, TNF-alpha, NF-kB), and promotes stem cell proliferation in preclinical models.",
    research_applications: [
      "Tissue remodeling and wound healing studies",
      "Collagen and elastin synthesis research",
      "Gene expression modulation investigations",
      "Antioxidant and anti-inflammatory pathway studies",
      "Copper chaperone mechanism research"
    ],
    cas_number: "49557-75-7",
    molecular_formula: "C14H23CuN6O4",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "50mg", price: 35 },
      { mg: "100mg", price: 45 }
    ],
    image_url: "https://images.unsplash.com/photo-1773429492523-20d3d5df05b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxzY2llbmNlJTIwbW9sZWN1bGFyJTIwc3RydWN0dXJlJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc2OTA2OTk0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Glow",
    slug: "glow",
    category: "Beauty",
    short_description: "Synergistic peptide blend of BPC-157, GHK-Cu, and TB-500 for tissue repair and regeneration research.",
    description: "Glow is a research-grade peptide blend combining three synergistic compounds: BPC-157 (Body Protection Compound-157), GHK-Cu (Copper Tripeptide-1), and TB-500 (Thymosin Beta-4 fragment). This formulation is designed for comprehensive tissue repair and regeneration research. BPC-157, a synthetic pentadecapeptide derived from gastric juices, is studied for its angiogenic and tissue-healing properties. GHK-Cu supports collagen synthesis and extracellular matrix remodeling. TB-500 promotes actin dynamics, cell migration, and anti-inflammatory responses. Together, these peptides target complementary repair pathways including NF-kB suppression and collagen modulation.",
    mechanism: "Multi-pathway activation through three complementary peptides: BPC-157 promotes angiogenesis and gut/vessel repair; GHK-Cu drives collagen synthesis and gene modulation via copper delivery; TB-500 enhances actin dynamics and cell migration. Combined, they target NF-kB suppression and broad tissue regeneration pathways.",
    research_applications: [
      "Synergistic peptide interaction studies",
      "Multi-pathway tissue repair research",
      "Angiogenesis and vessel formation investigations",
      "Collagen synthesis and ECM remodeling studies",
      "Anti-inflammatory mechanism research"
    ],
    cas_number: null,
    molecular_formula: null,
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "50mg", price: 60 },
      { mg: "70mg", price: 70 }
    ],
    image_url: "https://images.unsplash.com/photo-1773429492634-7e3920d2f8a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxwZXB0aWRlJTIwcmVzZWFyY2glMjB2aWFsJTIwbmVvbiUyMGRhcmt8ZW58MHx8fHwxNzc2OTA2OTk0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "MOTS-c",
    slug: "mots-c",
    category: "Restoration",
    short_description: "Mitochondrial-derived peptide for AMPK activation, metabolic regulation, and cellular energy research.",
    description: "MOTS-c (Mitochondrial Open Reading Frame of the 12S rRNA Type-C) is a 16-amino-acid mitochondrial-derived peptide encoded by a short open reading frame in the mitochondrial 12S rRNA gene. As a key signaling molecule in mitonuclear communication, MOTS-c regulates metabolism, stress responses, and cellular energy homeostasis. Under metabolic stress, MOTS-c translocates to the nucleus in an AMPK-dependent manner, binding transcription factors with antioxidant response elements to regulate nuclear gene expression. Research indicates it modulates the folate-methionine cycle and one-carbon metabolism, promoting glucose uptake and insulin sensitivity in preclinical models.",
    mechanism: "Primarily activates AMP-activated protein kinase (AMPK), the master metabolic regulator, by modulating the folate-methionine cycle. Promotes glucose uptake, glycolysis, and insulin sensitivity. Improves mitochondrial respiration, ATP production, and oxidative phosphorylation. Translocates to nucleus under stress to regulate gene expression via ARE-binding transcription factors.",
    research_applications: [
      "AMPK activation and metabolic signaling research",
      "Mitochondrial-derived peptide studies",
      "Mitonuclear communication investigations",
      "Insulin sensitivity and glucose metabolism research",
      "Cellular stress response and aging studies"
    ],
    cas_number: "1627580-64-6",
    molecular_formula: "C101H152N28O22S2",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "10mg", price: 50 },
      { mg: "40mg", price: 110 }
    ],
    image_url: "https://images.pexels.com/photos/35967917/pexels-photo-35967917.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    name: "NAD+",
    slug: "nad-plus",
    category: "Restoration",
    short_description: "Essential coenzyme for cellular energy production, DNA repair, and sirtuin activation research.",
    description: "NAD+ (Nicotinamide Adenine Dinucleotide) is an essential coenzyme found in all living cells, composed of two nucleotides linked by phosphate groups - one containing an adenine nucleobase and the other nicotinamide. As a critical electron shuttle in metabolic reactions, NAD+ drives core cellular processes including ATP generation via the mitochondrial electron transport chain, DNA repair through PARP enzyme activation, and gene regulation via sirtuin deacetylation. Research demonstrates that NAD+ levels decline significantly with age (up to 80% in some tissues), linking it to impaired metabolism and stress response. This compound is supplied for research into cellular energy pathways and age-related metabolic decline.",
    mechanism: "Acts as a coenzyme in redox reactions within mitochondria, facilitating ATP generation via the electron transport chain. Serves as a substrate for sirtuins (deacetylation), PARP enzymes (DNA repair), and cyclic ADP-ribose production. Maintains the NAD+/NADH ratio critical for balanced oxidizing/reducing cellular activity.",
    research_applications: [
      "Cellular energy metabolism and ATP production studies",
      "Sirtuin activation and gene regulation research",
      "DNA repair mechanism investigations (PARP pathway)",
      "Age-related metabolic decline studies",
      "Mitochondrial function and electron transport research"
    ],
    cas_number: "53-84-9",
    molecular_formula: "C21H27N7O14P2",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "500mg", price: 90 }
    ],
    image_url: "https://images.unsplash.com/photo-1675044794030-f8f4f6cdd92c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxzY2llbmNlJTIwbW9sZWN1bGFyJTIwc3RydWN0dXJlJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc2OTA2OTk0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Semax",
    slug: "semax",
    category: "Restoration",
    short_description: "Synthetic ACTH-derived heptapeptide for neurotrophic factor, cognitive, and neuroprotection research.",
    description: "Semax is a synthetic heptapeptide (Met-Glu-His-Phe-Pro-Gly-Pro) derived from the adrenocorticotropic hormone (ACTH) fragment 4-10. Designed as a neuropeptide analog, Semax is primarily researched for its nootropic and neuroprotective properties without significant adrenal stimulation. Studies demonstrate its ability to upregulate brain-derived neurotrophic factor (BDNF) and its receptor TrkB in the hippocampus, promoting synaptic plasticity, neuronal survival, and neurogenesis. Additionally, Semax modulates dopamine and serotonin turnover, enhances acetylcholine metabolism, and exhibits anti-inflammatory properties through nitric oxide synthesis inhibition and oxidative stress reduction in preclinical models.",
    mechanism: "Upregulates BDNF and TrkB receptor expression in the hippocampus, promoting synaptic plasticity and neuronal survival. Enhances dopamine and serotonin turnover/release and modulates acetylcholine metabolism. Inhibits nitric oxide synthesis, reduces oxidative stress and inflammation. May interact with melanocortin receptors (MC4/MC5) and inhibit enkephalinase.",
    research_applications: [
      "BDNF and neurotrophic factor research",
      "Synaptic plasticity and neurogenesis studies",
      "Neuroprotection mechanism investigations",
      "Neurotransmitter modulation research",
      "Cognitive function and memory pathway studies"
    ],
    cas_number: "80714-61-0",
    molecular_formula: "C37H51N7O10S",
    purity: ">99%",
    form: "Lyophilized Powder",
    storage: "Store at -20C. Keep away from direct sunlight.",
    variants: [
      { mg: "10mg", price: 30 }
    ],
    image_url: "https://images.unsplash.com/photo-1773429494448-1c13750ad80d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxwZXB0aWRlJTIwcmVzZWFyY2glMjB2aWFsJTIwbmVvbiUyMGRhcmt8ZW58MHx8fHwxNzc2OTA2OTk0fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const FAQ_ITEMS = [
  {
    id: "faq-1",
    question: "What are research peptides?",
    answer: "Research peptides are synthetic or naturally derived short chains of amino acids used exclusively in laboratory and scientific research settings. They serve as valuable tools for studying biological mechanisms, receptor interactions, cellular signaling pathways, and potential therapeutic targets. All peptides sold by Apollo Compounds are intended strictly for in vitro research and laboratory use."
  },
  {
    id: "faq-2",
    question: "Are your products intended for human consumption?",
    answer: "No. All products offered by Apollo Compounds are strictly for research purposes only and are not intended for human or animal consumption, diagnostic use, or therapeutic application. Our compounds are sold exclusively to qualified researchers, academic institutions, and licensed laboratories for in vitro and scientific investigation."
  },
  {
    id: "faq-3",
    question: "What purity levels do your peptides maintain?",
    answer: "All Apollo Compounds peptides are manufactured to a minimum purity of >99% as verified by High-Performance Liquid Chromatography (HPLC) and Mass Spectrometry (MS) analysis. Each batch undergoes rigorous quality control testing, and Certificates of Analysis (COA) are available upon request for every product."
  },
  {
    id: "faq-4",
    question: "How should research peptides be stored?",
    answer: "For optimal stability, lyophilized (freeze-dried) peptides should be stored at -20C or below in a dry environment, protected from direct sunlight. Once reconstituted, peptide solutions should be stored at 2-8C and used within a reasonable timeframe. Avoid repeated freeze-thaw cycles as this may compromise compound integrity."
  },
  {
    id: "faq-5",
    question: "Do you ship internationally?",
    answer: "Apollo Compounds is a US-based supplier primarily serving domestic research institutions and laboratories. International shipping availability varies by destination and is subject to applicable import regulations and customs requirements. Please contact our team directly for international shipping inquiries."
  },
  {
    id: "faq-6",
    question: "What forms do your peptides come in?",
    answer: "All of our research compounds are supplied as lyophilized (freeze-dried) powder in sterile, sealed vials. This form ensures maximum stability and shelf life. Reconstitution protocols are available upon request for each specific compound."
  },
  {
    id: "faq-7",
    question: "Can I request a Certificate of Analysis (COA)?",
    answer: "Yes. Certificates of Analysis are available for all products and can be requested through our contact form or by reaching out to our support team directly. Each COA includes HPLC purity data, mass spectrometry confirmation, and batch-specific quality metrics."
  },
  {
    id: "faq-8",
    question: "What is the difference between different mg options for the same compound?",
    answer: "The different milligram (mg) options represent varying quantities of the same research compound per vial. The purity, formulation, and quality remain identical across all size options. Larger quantities are offered at more economical per-milligram pricing for researchers requiring greater volumes for extended studies."
  }
];
